import React from "react";
import MasterDetailLayout from "../../../../components/layout/MasterDetailLayout";
import CustomerCompactList from "../components/CustomerCompactList";

// Parent route element for the Customer master-detail split - second module
// on this pattern after Employee Master. See AppRoutes.jsx for how
// index/new/:branchId/:custId/(edit|guarding|bulk-guards|field-visits) nest
// under this instead of being flat, full-page routes.
const CustomerSplitView = () => <MasterDetailLayout list={<CustomerCompactList />} />;

export default CustomerSplitView;
